export default{
    address:{
        btnState:{
            btn1:'Save',
        },
        fromtitle:{
            from1:'Region',
            from2:'Detailed Address',
            from3:'Postal Code',
            from4:'Recipient Name',
            from5:'Contact Number',
            from6:'Set as default shipping address (System will automatically select this address during checkout)',
            from7:'You have added',
            from8:'Please enter',
            from9:'Action',
            from10:'shipping addresses, can still add',
            from11:'more'
        },
        tableList:{
            table1:'No data',
            table2:'Edit',
            table3:'Delete',
            table4:'Default Address',
            table5:'Set as Default',
            table6:'Select Region',
            table7:'Default'
        },
        rulesObj:{
            rules1:'Please select a region',
            rules2:'Please enter a detailed address (4-50 characters)',
            rules3:'Please enter postal code',
            rules4:'Please enter recipient name (2-10 characters)',
            rules5:'Please enter phone number',
            rules6:'Please enter a valid phone number',
        },
        confirmState:{
            confirm1:'Notification',
            confirm2:'Confirm',
            confirm3:'Cancel',
            confirm4:'Cancelled',
            confirm5:'Delete this address?',
            confirm6:'Address deleted successfully!',
            confirm7:'Set as default successfully!',
        }
    }
}